import React from 'react'

import { track } from 'analytics'
import { Disclosure } from 'components/dataDisplay'

import messages from './messages'


const FaqContent: React.FunctionComponent = () => (
  <>
    {
      messages.items.map(({ question, answer }, index) => (
        <Disclosure
          key={index}
          title={question}
          titleStyle="p2"
          text={answer}
          onClick={() => {
            track('FAQ question click', {
              title: question.en,
            })
          }}
        />
      ))
    }
  </>
)


export default React.memo(FaqContent)
